export function isFilteredBy(_a) {
    var referenceValues = _a.referenceValues, includeValue = _a.includeValue;
    if (!includeValue) {
        return true;
    }
    var isIncludedValue = false;
    var sanitizedIncludedValue = includeValue.trim().toLowerCase();
    referenceValues.forEach(function (value) {
        var sanitizedReferenceValue = value && value.trim().toLowerCase();
        var referenceIncludeValue = sanitizedReferenceValue && sanitizedReferenceValue.includes(sanitizedIncludedValue);
        if (referenceIncludeValue) {
            isIncludedValue = true;
        }
    });
    return isIncludedValue;
}
